<template>

<div id="personInfoComponentContainer" v-if="this.myData != null">

    <div class="card text-center">
      <div class="card-header">
        <h4 tabindex="0">Person Details</h4>
      </div>
      <div class="card-body">
     
        <div class="row">
          <div class="col">
            <span tabindex="0" class="personInfoLabel">Name: </span>
            <span tabindex="0" class="personInfoDataElement">{{this.myData.name}}</span>
          </div>
          <div class="col">
            <span tabindex="0" class="personInfoLabel">Contract Number: </span>
            <span tabindex="0" class="personInfoDataElement">{{myData.contractnumber}}</span>
          </div>
          <div class="col">
            <span tabindex="0" class="personInfoLabel">Security Type: </span>
            <span tabindex="0" class="contractHelperComponentDataElement">{{ myData.securityTypeName }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <span tabindex="0" class="personInfoLabel">Status: </span>
            <span tabindex="0" class="personInfoDataElement">{{myData.armStatDisplay}}</span>
          </div>
          <div class="col">
            <span tabindex="0" class="personInfoLabel">Nationality: </span>
            <span tabindex="0" class="personInfoDataElement">{{myData.countryName}}</span>
          </div>
          <div class="col">
            <span tabindex="0" class="personInfoLabel">Person Id: </span>
            <span tabindex="0" class="contractHelperComponentDataElement">{{myData.personId}}</span>
          </div>
        </div>

      </div>


      <div>

        <slot name="footer">
          <TooltipHelper position="top" tooltip-text="Click to Review/Update this Person.">
            <a @click="this.$emit('personInfo_editPerson_clicked');" href="#">Review/Update Person</a>
          </TooltipHelper>
        </slot>
        
      </div>
    </div>

  </div>

  <div class="personInfoComponentContainer" v-else>
    
  </div>

</template> 
  
<script> 

  import TooltipHelper from '../dataSupport/TooltipHelper.vue';
  
  export default {
    name: "EditPersonForm",
    components: {
      TooltipHelper
    }, 
    data(){
      return{
        isMounted : false,
        myData:null,
      }
    },
    props: {
      personObject:Object,
    },
    created(){ // called BEFORE rendering (load data here)
      
    },
    mounted() { // called afer rendering
   
      this.myData = this.personObject;
        //  console.log("person info created", this.myData);
    },

    methods:{
      Em(){

      }
    },
    unmounted(){ //called when the page is left or the component is destroyed

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    }
  }
</script>
  
<style scoped>
 #personInfoComponentContainer{
    display:flex;
    width: 85%;
    margin-left:auto;
    margin-right:auto;
    margin-bottom:15px;
    min-height:200px;
  }
  #personInfoComponentContainer .card{
    flex-grow: 1;
    text-align:left;
  }
  #personInfoComponentContainer .row{
    text-align:left;
  }
  #personInfoComponentContainer .col{
    display:flex;
  }
  .personInfoLabel{
    min-width: 180px;
    text-align: right;
    font-weight: bold;
    padding-right:10px;
  }

  .card-header{
    background:#8982e6;
    color:white;
  }
  .card-body{
    background:#D0CDF5;
  }
</style>
